import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
/**
 * This hook polls braze until braze is ready and intitialized, then triggers a custom event
 *
 * @param skip: boolean
 * @param brazeEvent: string, name of braze custom event
 */
var useBrazeTriggerCoupon = function useBrazeTriggerCoupon(_ref) {
  var skip = _ref.skip,
    brazeEvent = _ref.brazeEvent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isBrazeReady = _useState2[0],
    setIsBrazeReady = _useState2[1];
  var pollCount = 0;
  useEffect(function () {
    var brazeReadyPoll;
    if (!skip && !isBrazeReady) {
      var isInitialized = window.braze && window.braze.initialize();
      if (isInitialized) {
        var _window$braze;
        (_window$braze = window.braze) === null || _window$braze === void 0 || _window$braze.logCustomEvent(brazeEvent);
        setIsBrazeReady(true);
      } else {
        brazeReadyPoll = setInterval(function () {
          var isInitialized = window.braze && window.braze.initialize();
          if (isInitialized) {
            var _window$braze2;
            clearInterval(brazeReadyPoll);
            (_window$braze2 = window.braze) === null || _window$braze2 === void 0 || _window$braze2.logCustomEvent(brazeEvent);
            setIsBrazeReady(true);
          }
          pollCount += 1;
          /** We don't want to poll forever if braze is not available */
          if (pollCount > 15) {
            clearInterval(brazeReadyPoll);
          }
        }, 1000);
      }
    }
    return function () {
      return clearInterval(brazeReadyPoll);
    };
  }, [skip]);
};
export default useBrazeTriggerCoupon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/hooks/useBrazeTriggerCoupon.js
// module id = 4119
// module chunks = 11